"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tfs_css_variables_1 = __importDefault(require("tfs.css-variables"));
exports.default = {
    text: {
        lineHeight: '1rem',
        marginLeft: '0.5rem',
        fontSize: '1.5rem',
        fontFamily: 'Nexa',
        fontWeight: 'bold',
        color: tfs_css_variables_1.default.colorGreen,
    },
};
//# sourceMappingURL=LogoContent.styles.js.map